import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

const RecurringDifferencesTable = ({ data = [], loading }) => {
  if (!loading && !data.length) return null;

  return (
    <Paper elevation={2} sx={{ p: 2, mt: 2 }}>
      <Typography variant="subtitle1" gutterBottom>⚠️ Ítems con diferencias recurrentes de conteo</Typography>
      {loading ? (
        <Skeleton variant="rectangular" height={160} />
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Sucursal</TableCell>
                <TableCell>Ítem</TableCell>
                <TableCell>Tipo</TableCell>
                <TableCell align="right">Ajustes</TableCell>
                <TableCell align="right">Última diferencia</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow key={`${row.locationId}-${row.referenceType}-${row.referenceId}`} hover>
                  <TableCell>{row.locationName}</TableCell>
                  <TableCell>{row.referenceName || `#${row.referenceId}`}</TableCell>
                  <TableCell>{row.referenceTypeLabel}</TableCell>
                  <TableCell align="right">{row.adjustmentCount}</TableCell>
                  <TableCell align="right">{row.lastDifference > 0 ? `+${row.lastDifference}` : row.lastDifference}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default RecurringDifferencesTable;
